export const LeadsTypesEnum = {
  Buy: {
    key: 'Buy',
    value: 'buyer',
  },
  Rent: {
    key: 'Rent',
    value: 'tenant',
  },
  Owner: {
    key: 'Owner',
    value: 'buyer-or-seller',
  },
  Seeker: {
    key: 'Seeker',
    value: 'landlord-or-tenant',
  },
};
